export default "__VITE_ASSET__CFvyOe$X__"